<div>
    <div mat-dialog-title oneDialogTitle>
        <span i18n="@@input-dialog-example.title">LSO Acknowledgement</span>
    </div>
    <div mat-dialog-content oneDialogContent>
        <mat-form-field appearance="outline" oneFormField style="width: 100%; flex: 1;">
            <mat-label>Comments</mat-label>    
            <input matInput value="" [formControl]="commentText">
            <button mat-icon-button one-icon-button matSuffix (click)="commentText.setValue('')" style="height: 27px;" *ngIf="commentText.value">
                <mat-icon i18n-aria-label="@@buttons.icon-buttons-example-button" matSuffix>clear</mat-icon>
            </button>
        </mat-form-field>

        <div>
            <h3>Attachment (maximum size: 15 MB):</h3>
            <dl-file-upload-single [ackFileFlag]="false"></dl-file-upload-single>
        </div>
    </div>
    <div mat-dialog-actions oneDialogActions class="import-dialog-actions">
        <button one-secondary-button mat-stroked-button [mat-dialog-close]="true" title="Cancel">Cancel</button>
        <button color="primary" mat-flat-button title="Acknowledge"  [disabled]="!commentText.value" (click)="sendAckDetails()">Acknowledge</button>
    </div>
</div>